import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import {catchError} from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable()
export class MarketingCopyService extends BaseHttpService {

  private rootUrl: string = 'market-copy';

  isSavedSubject: Subject<void> = new Subject<void>();
  isSavedObservable = this.isSavedSubject.asObservable();

  fetchMarketCopy(brandId: string): Observable<any> {
    return this.http.get(`${Config.API}/${this.rootUrl}/${brandId}`)

        .pipe(catchError(this.handleError.bind(this)));
  }

  putMarketCopy(brandId: string, data: any, publish: boolean= false): Observable<any> {
    const body = JSON.stringify({ data, publish });
    return this.http.put(`${Config.API}/${this.rootUrl}/${brandId}`, body, {headers: contentHeaders})

        .pipe(catchError(this.handleError.bind(this)));
  }

  fetchLookup(brandId: string, name: string): Observable<any> {
    return this.http.get(`${Config.API}/${this.rootUrl}/${brandId}/${name.toLowerCase()}`)

        .pipe(catchError(this.handleError.bind(this)));
  }

  fetchBrand(brandId: string): Observable<any> {
    return this.fetchLookup(brandId, 'brd');
  }

  fetchBrandOwner(brandId: string): Observable<any> {
    return this.fetchLookup(brandId, 'bow');
  }

  fetchSubBrand(brandId: string): Observable<any> {
    return this.fetchLookup(brandId, 'sbr');
  }

  fetchPartType(brandId: string): Observable<any> {
    return this.fetchLookup(brandId, 'pti');
  }

  fetchProductGroup(brandId: string): Observable<any> {
    return this.fetchLookup(brandId, 'pgc');
  }

  fetchProductSubGroup(brandId: string): Observable<any> {
    return this.fetchLookup(brandId, 'psg');
  }

  fetchProductCategoryCode(brandId: string): Observable<any> {
    return this.fetchLookup(brandId, 'pcc');
  }
  emitIsSaved() {
    this.isSavedSubject.next();
  }
}
